import axios from "axios";
import { notifyApiFailure, notifyApiSuccess } from "@/helpers/apiStatus";

// Public site API helper.
// No auth interceptor, no X-Company-Id header — backend resolves company
// from JcPublic:DefaultCompanyId in appsettings.json (single-tenant).
const api = axios.create({
  baseURL: (process.env.VUE_APP_API_BASE_URL || "http://localhost:5293/api"),
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

// Resolve relative upload paths (e.g. "uploads/jc-team-members/1/abc.png") to absolute URLs.
export function assetUrl(relative) {
  if (!relative) return "";
  if (/^https?:/i.test(relative)) return relative;
  const base = (process.env.VUE_APP_API_BASE_URL || "http://localhost:5293/api").replace(/\/api\/?$/, "");
  return `${base}/${relative}`.replace(/([^:])\/\//g, "$1/");
}

// Link to the authenticated portal app (vue/jobie). Overridable via env.
export function portalUrl(path = "") {
  const base = (process.env.VUE_APP_PORTAL_URL || "http://localhost:8071").replace(/\/$/, "");
  return `${base}${path}`;
}

// Response interceptor — the public site has no auth to handle, so this exists purely
// to feed the outage monitor. helpers/apiStatus.js probes /health and shows one global
// notice while the API is unreachable (typically a release in flight).
api.interceptors.response.use(
  (response) => {
    notifyApiSuccess();
    return response;
  },
  (error) => {
    notifyApiFailure(error);
    return Promise.reject(error);
  }
);

export default api;
